import { render, staticRenderFns } from "./statement_object_dialog.vue?vue&type=template&id=60479bdf&"
import script from "./statement_object_dialog.vue?vue&type=script&lang=js&"
export * from "./statement_object_dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports